import { useMutation, useQueryClient } from "@tanstack/react-query";
import fetchToBackend, { type BackendError } from "@/utils/fetchToBackend";
import { companyKeys, contractingKeys, viewQuotaKeys } from "@/lib/query-keys";
import { toastUtil } from "@/utils/toastUtil";
import { capture } from "@/lib/posthog";
import type { UnlockPageResult } from "@/types/domain";

/**
 * "Desbloquear las de esta página": el backend desbloquea en el orden recibido
 * hasta que se acaben las vistas y cruza lo que se pueda. Refresca lo mismo que
 * un desbloqueo suelto.
 */
export function useUnlockPage() {
  const qc = useQueryClient();
  return useMutation<UnlockPageResult, BackendError, { contractingIds: number[] }>({
    mutationFn: ({ contractingIds }) =>
      fetchToBackend<UnlockPageResult>("/contractings/unlock-page", {
        method: "POST",
        body: JSON.stringify({ contractingIds }),
      }),
    onSuccess: (result) => {
      capture("contracting_page_unlocked", {
        unlocked: result.unlocked,
        requested: result.requested,
      });
      qc.invalidateQueries({ queryKey: contractingKeys.lists() });
      qc.invalidateQueries({ queryKey: contractingKeys.details() });
      qc.invalidateQueries({ queryKey: companyKeys.all });
      qc.invalidateQueries({ queryKey: viewQuotaKeys.all });
      qc.invalidateQueries({ queryKey: contractingKeys.qualification() });
    },
    onError: () => toastUtil("No se pudieron desbloquear las oportunidades.", "error"),
  });
}
